/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivery_Failed_PlaceholderInputs */

const vi_order_carrier_delivery_failed_placeholder = /** @type {(inputs: Order_Carrier_Delivery_Failed_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: Khách từ chối nhận hàng do sai số lượng`)
};

/**

* @param {Order_Carrier_Delivery_Failed_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivery_failed_placeholder = /** @type {((inputs?: Order_Carrier_Delivery_Failed_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivery_Failed_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivery_failed_placeholder(inputs)
});